export default __webpack_public_path__ + "maps-guides-view-annotation-marker-popup-960-ba6d4c1dac03d7355f925855c0098d2f.webp";